import { CardTable } from 'shared/mui/Card/CardTableNew/CardTable';
import { TableRowWrapper } from 'shared/mui/Table/TableRowWrapperNew/TableRowWrapper';
import { DateTimeField } from 'shared/react-admin/Fields';

export const RequestsBankOpsShowTabsHistory: React.FC = () => {
  return (
    <CardTable tableBodyProps={{ sx: { '& td': { width: '200px' } } }}>
      <TableRowWrapper label="Дата создания">
        <DateTimeField inline source="createdAt" />
      </TableRowWrapper>
      <TableRowWrapper label="Дата редактирования">
        <DateTimeField inline source="updatedAt" />
      </TableRowWrapper>
    </CardTable>
  );
};
